<aside class="admin-sidebar" [class.is-collapsed]="collapsed" [class.is-mobile-open]="mobileOpen">

  <!-- Brand -->
  <div class="sidebar-brand" (click)="goHome()" style="cursor:pointer">
    <div class="sidebar-brand-icon">
      <img src="/web/icon-512.png" alt="Trieon.HR" class="brand-logo" />
    </div>
    <div class="sidebar-brand-text">
      <span class="name brand-name">Trieon<span class="brand-accent">.HR</span></span>
    </div>
  </div>

  @if (!collapsed && (showSearch || showNavControls)) {
    <div class="sidebar-toolbar" [class.sidebar-toolbar--compact]="!showSearch">
      @if (showSearch) {
        <div class="sidebar-search">
          <span class="pi pi-search sidebar-search-icon"></span>
          <input
            type="search"
            class="sidebar-search-input"
            name="nav-menu-filter"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
            readonly
            placeholder="Search menu..."
            [(ngModel)]="searchQuery"
            (focus)="enableMenuSearch($event)"
            (ngModelChange)="onSearchChange()"
            aria-label="Search navigation menu" />
        </div>
      }
      @if (showNavControls) {
        <button
          type="button"
          class="sidebar-nav-toggle"
          (click)="toggleAllPanels()"
          [attr.aria-label]="allSectionsExpanded ? 'Collapse all sections' : 'Expand all sections'"
          [title]="allSectionsExpanded ? 'Collapse all' : 'Expand all'">
          <span
            class="pi"
            [class.pi-angle-double-up]="allSectionsExpanded"
            [class.pi-angle-double-down]="!allSectionsExpanded"></span>
        </button>
      }
    </div>
  }

  <!-- Navigation -->
  <nav class="sidebar-nav" data-tour="sidebar-nav">

    @if (collapsed) {
      <div class="sidebar-nav-collapsed">
        @for (panel of navMenu; track panel.label) {
          @if (panel.items && panel.items.length > 0) {
            <button
              type="button"
              class="nav-section-collapsed-btn"
              [class.is-active]="isPanelActive(panel)"
              [class.is-open]="openFlyoutPanel === panel.label"
              (click)="toggleCollapsedFlyout(panel.label, $event)"
              [title]="formatPanelLabel(panel.label)"
              [attr.aria-label]="formatPanelLabel(panel.label)"
              [attr.aria-expanded]="openFlyoutPanel === panel.label">
              <span class="nav-section-icon-wrap">
                <span [class]="panelIcon(panel) + ' nav-section-icon'"></span>
              </span>
            </button>
          }
        }
      </div>
    } @else {
      @for (panel of displayNavMenu; track panel.label) {
        @if (panel.items && panel.items.length > 0) {
          <div class="nav-section" [class.is-expanded]="isPanelExpanded(panel.label)">
            <button
              type="button"
              class="nav-section-header"
              (click)="togglePanel(panel.label)"
              [attr.aria-expanded]="isPanelExpanded(panel.label)">
              <span class="nav-section-icon-wrap">
                <span [class]="panelIcon(panel) + ' nav-section-icon'"></span>
              </span>
              <span class="nav-section-title">{{ formatPanelLabel(panel.label) }}</span>
              <span class="pi nav-section-chevron" [class.pi-chevron-down]="!isPanelExpanded(panel.label)" [class.pi-chevron-up]="isPanelExpanded(panel.label)"></span>
            </button>

            @if (isPanelExpanded(panel.label)) {
              <div class="nav-section-body">
                @for (item of panel.items; track item.label) {
                  @if (item.items && item.items.length > 0) {
                    <div class="nav-group" [class.is-expanded]="isGroupExpanded(panel.label, item.label)">
                      <button
                        type="button"
                        class="nav-group-header"
                        (click)="toggleGroup(panel.label, item.label)"
                        [attr.aria-expanded]="isGroupExpanded(panel.label, item.label)">
                        <span [class]="iconClass(item.icon)"></span>
                        <span class="nav-group-label">{{ item.label }}</span>
                        <span class="pi pi-chevron-down nav-group-chevron"></span>
                      </button>

                      @if (isGroupExpanded(panel.label, item.label)) {
                        <div class="nav-group-body">
                          @for (subitem of item.items; track subitem.label) {
                            <a [routerLink]="subitem.route" routerLinkActive="active" class="tp-nav-link tp-nav-sublink">
                              <span [class]="iconClass(subitem.icon)"></span>
                              <span>{{ subitem.label }}</span>
                            </a>
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <a [routerLink]="item.route" routerLinkActive="active" class="tp-nav-link">
                      <span [class]="iconClass(item.icon)"></span>
                      <span>{{ item.label }}</span>
                    </a>
                  }
                }
              </div>
            }
          </div>
        }
      }

      @if (searchQuery.trim() && displayNavMenu.length === 0) {
        <p class="sidebar-search-empty">No menu items match your search.</p>
      }
    }

  </nav>

  @if (collapsed && openFlyoutPanel) {
  <div class="sidebar-flyout-backdrop" (click)="closeCollapsedFlyout()"></div>
  <div
    class="sidebar-flyout"
    [style.top.px]="flyoutTop"
    [style.left.px]="flyoutLeft"
    (click)="onFlyoutClick($event)"
    role="menu">
    <span class="sidebar-flyout-arrow" [style.top.px]="flyoutArrowTop"></span>
    @if (getPanelByLabel(openFlyoutPanel); as panel) {
      <div class="sidebar-flyout-content">
        <p class="sidebar-flyout-title">{{ formatPanelLabel(panel.label) }}</p>
        <div class="sidebar-flyout-body">
        @for (item of panel.items; track item.label) {
          @if (item.items && item.items.length > 0) {
            <p class="sidebar-flyout-group">{{ item.label }}</p>
            @for (subitem of item.items; track subitem.label) {
              <a
                [routerLink]="subitem.route"
                routerLinkActive="active"
                class="sidebar-flyout-link"
                (click)="onFlyoutLinkClick()"
                role="menuitem">
                <span [class]="iconClass(subitem.icon)"></span>
                <span>{{ subitem.label }}</span>
              </a>
            }
          } @else {
            <a
              [routerLink]="item.route"
              routerLinkActive="active"
              class="sidebar-flyout-link"
              (click)="onFlyoutLinkClick()"
              role="menuitem">
              <span [class]="iconClass(item.icon)"></span>
              <span>{{ item.label }}</span>
            </a>
          }
        }
      </div>
      </div>
    }
  </div>
  }

  <!-- User Footer -->
  <div class="sidebar-user">
    <a class="sidebar-user-inner" routerLink="/me/profile" title="My Profile">
      <div class="sidebar-user-avatar">{{ userProfileStore.initials() }}</div>
      <div class="sidebar-user-text">
        <p class="sidebar-user-name">{{ userProfileStore.fullName() }}</p>
        <p class="sidebar-user-role">{{ userProfileStore.roleName() }}</p>
      </div>
      <span class="pi pi-user sidebar-user-icon"></span>
    </a>
  </div>

</aside>
